<template>
    <Card :title="$t('labels.client')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.name')" :required="true">
                        <InputAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/clients`"
                            :model-value="name"
                            :query-params="{
                                orders: [
                                    { column: 'name', dir: 'asc'}
                                ]
                            }"
                            @update:modelValue="name = $event"
                            @select="handleSelection"
                        >
                            <template #optionItem="{option, index}">
                                {{ option.name }}<br/><span v-if="option.email || option.phone" class="text-muted"> ({{ option.phone || option.email }})</span>
                            </template>
                        </InputAutoComplete>
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.email')">
                        <InputAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/clients`"
                            :model-value="email"
                            :query-params="{
                                orders: [
                                    { column: 'email', dir: 'asc'}
                                ]
                            }"
                            option-value="email"
                            @update:modelValue="email = $event"
                            @select="handleSelection"
                        >
                            <template #optionItem="{option, index}">
                                {{ option.name }}<br/><span v-if="option.email || option.phone" class="text-muted"> ({{ option.email }})</span>
                            </template>
                        </InputAutoComplete>
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.phone')">
                        <InputAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/clients`"
                            :model-value="phone"
                            :query-params="{
                                orders: [
                                    { column: 'phone', dir: 'asc'}
                                ]
                            }"
                            option-value="phone"
                            @update:modelValue="phone = $event"
                            @select="handleSelection"
                            mask="+38 (###) ###-##-##"
                            placeholder="+38 (999) 999-99-99"
                        >
                            <template #optionItem="{option, index}">
                                {{ option.name }}<br/><span v-if="option.email || option.phone" class="text-muted"> ({{ option.phone }})</span>
                            </template>
                        </InputAutoComplete>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.create') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import InputAutoComplete from "../../../../components/new/form/autocomplete/InputAutoComplete.vue";
import Button from "../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";

export default {
    name: "ClientCreatePage",
    components: {
        Card, FormGroup, InputAutoComplete, Button
    },
    data() {
        return {
            name: '',
            email: '',
            phone: ''
        }
    },
    methods: {
        handleSelection(option) {
            this.$router.push({
                name: 'ClientEditPage',
                params: {
                    clientUuid: option.uuid
                }
            });
        },
        async create() {
            await httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/clients`, {
                name: this.name,
                email: this.email,
                phone: this.phone
            }).then((response) => {
                this.$router.push({name: "ClientEditPage", params: { clientUuid: response.data.data.uuid }});
                new MessageNotificator().success(this.$t("alerts.success"))
            })
        }
    }
}
</script>